import styled from 'styled-components'

export const Container = styled.div`
	min-height: 82vh;

	main {
		padding: 35px 50px 35px 90px;

		h1 {
			margin-bottom: 20px;
		}

		@media(max-width: 760px) {
			padding: 20px;
		}

		@media(max-width: 440px) {
			padding: 20px 0;
		}
	}
`
